<template>
  <div class="Index">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Index',
  components: {},
  data () {
    return {
      start: true,
      moduleName: ''
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {

  }
}
</script>

<style scoped lang="scss">
</style>
